<!--
 * @Descripttion: 入仓确认商品信息
 * @Date: 2021-06-03 15:29:50
 * @LastEditors: Sima thief
 * @LastEditTime: 2021-06-30 15:51:54
 * @Author: Sima thief
-->

<template>
  <div class="page">
    
    <el-table
      :data="inWarehouseDetailOrderDTO.inWarehouseGoodsDTOList"
      style="width: 100%"
    >
      <el-table-column prop="detailOrderNo" label="运单号" width="180">
      </el-table-column>
      <el-table-column prop="weight" label="重量（kg）" width="180">
      </el-table-column>
      <el-table-column prop="cbm" label="体积（CBM）"> </el-table-column>
    </el-table>
    <div class="all flex-container">
      <div class="flex-item">
        <span class="text">入仓总重量(KG)</span>
        {{ inWarehouseDetailOrderDTO.confirmAllWeight }}
      </div>
      <div class="flex-item">
        <span class="text">入仓总体积(CBM)</span
        >{{ inWarehouseDetailOrderDTO.confirmAllCbm }}
      </div>
      <div class="flex-item=">
        <span class="text">入仓总箱数</span>
        {{inWarehouseDetailOrderDTO.confrimBoxNum }}
      </div>
      <div class="flex-item">
        <span class="text">入仓时间</span>
        {{ inWarehouseDetailOrderDTO.storageTime }}
      </div>
    </div>
    <div class="mr-top-10 btn">入仓确认费用详情</div>
    <el-table
      :data="inWarehouseDetailOrderDTO.orderFeeDTOS"
      style="width: 100%"
    >
      <el-table-column prop="detailOrderNo" label="运单号" width="180">
      </el-table-column>
      <el-table-column prop="feeName" label="服务名称" width="180">
      </el-table-column>
      <el-table-column prop="num" label="数量"> </el-table-column>
      <el-table-column prop="price" label="单价"> </el-table-column>
      <el-table-column prop="currency" label="币种"> </el-table-column>
      <el-table-column prop="calcDesc" label="计算过程"> </el-table-column>
      <el-table-column prop="amount" label="总价"> </el-table-column>
    </el-table>
  
  </div>
</template>

<script>
export default {
  name: "Giowc",
  props: {
    inWarehouseDetailOrderDTO: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
 
};
</script>
<style lang="scss" scoped>
@import "../styles/index.scss";
.all {
  height: 80px;
  line-height: 80px;
  background-color: rgba(242, 242, 242, 1);
}
.flex-item {
  text-align: center;
}
.text {
  font-size: 16px;
}
.btn {
  width: 217px;
  height: 46px;
  line-height: 46px;
  text-align: center;
  border: rgba(215, 215, 215, 1) 1px solid;
  color: #5f4aff;
}

</style>




// WEBPACK FOOTER //
// src/components/mainOrders/components/Giowc.vue